import { Box } from '@mui/material';

interface ProgressBarProps {
  progressFraction: number;
  skinny?: boolean;
  backgroundColor?: string;
  progressColor?: string;
}

export const ProgressBar = ({
  progressFraction,
  skinny = false,
  backgroundColor = 'grey75',
  progressColor = 'secondary.main',
}: ProgressBarProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: skinny ? 2 : 6,
        backgroundColor,
        borderRadius: 2,
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          height: 'inherit',
          width: `${progressFraction * 100}%`,
          backgroundColor: progressColor,
        }}
      />
    </Box>
  );
};
